import React from 'react'
import { useParams } from 'react-router-dom'
import { jewellerydata } from '../DUMMYDATA/DUMMYDATA';

const CategoryDetail = () => {
    const {category} = useParams();
    const categoryData = jewellerydata.find((data)=>data.category.toLowerCase() === category);
    if(!categoryData){
        return <div className='mt-[9rem]'> <h2 className='text-center text-[22px] font-normal text-red-800'> Category not found</h2></div>
    }
  return (
    <section className='mt-[9rem]'>
        <div className='mx-[100px] my-14'>
            <h2 className='text-center text-[22px] uppercase mb-14 text-tertary2 font-bold'>{categoryData.category}</h2>
            <div className='grid lg:grid-cols-4 md:grid-cols-3 gap-4'>
                {/* category item data */}
                {categoryData.items.map((item) => (
                    <div key={item.id} className='col-span-1 mt-8'>
                        <img src={item.img} alt={item.name} className='w-full' />
                        <h3 className='text-center text-[13px] font-medium mt-2'>
                            {item.name}
                        </h3>
                        <p className='text-center text-[13px] pt-1'>{item.material}</p>
                        {/* <p className='text-center text-[14px] mt-1'>{item.description}</p> */}
                    </div>
                ))}
            </div>
        </div>
    </section>
  )
}

export default CategoryDetail